import React, { useState } from "react";
import "./yourgoals.scss";
import { Card } from "react-bootstrap";
import { Headings } from "../../atoms/Headings";
import { ModalOverlay } from "../../atoms/Modal";
import LoadingSpinner from "../../atoms/Loader";
const YourGoals = (props) => {
  const [modalShow, setModalShow] = useState(false);
  const { investorId, goalsFetching } = props;
  //eslint-disable-next-line no-unused-vars
  const [isTaskUpdated, setIsTaskUpdated] = useState(
    props?.isTaskUpdated ? props?.isTaskUpdated : false,
  ); //eslint-disable-line

  return (
    <>
      <Card className="your-goals mb-4 mb-md-0">
        <Card.Body>
          <Card.Text className="custom-bottom-text">
            <Headings
              title="Your goals"
              seeAllGoals="See all"
              handleClick={() => setModalShow(true)}
              headIconName="goals"
              headIconVariant="icon-fourty-eight-px"
            />
            {(!modalShow && goalsFetching) || props?.postLoading ? (
              <LoadingSpinner />
            ) : (
              <>{props?.RadioBtnComp}</>
            )}
          </Card.Text>
        </Card.Body>
      </Card>
      <ModalOverlay
        show={modalShow}
        onHide={() => setModalShow(false)}
        modalTitle="Your Goals"
        investorId={investorId}
        isTaskUpdated={isTaskUpdated}
        popup="yourgoals"
        setModalShow={setModalShow}
      />
    </>
  );
};

export default YourGoals;
